import { TextField } from '@mui/material'
import React,{useState} from 'react'
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Header from './Header';

const Calculater2 = () => {

  const [num1,setNum1] = useState(0);
  const [num2,setNum2] = useState(0);
  const [num3,setNum3] = useState(0);
  const [Add,setAdd] = useState("");
 
  const calcSum = (e) => {
    e.preventDefault()
    console.log(e);
 
    if(num1===0 || num2===0 || num3===0)
      {
        alert("please put all inputs")
      }
       
      else
      {
        let Add = parseInt(num1)*parseInt(num2)*parseInt(num3)/100;
        // console.log(typeof(Add));
        setAdd(parseInt(Add))
      }
 
  }
  
  const handleClick = (e) => {
    setAdd(0);
    window.location.reload();
 
  }
  
  return (<>
    <Header/>
    <div className='body2'>
     
    <div className="card">
    <div className='heading_text'>
          <h1 className='heading_one'>Simple interest Calculator</h1>
          <p className='heading_two'>Calculate your simple interest Easily</p>
        </div>
        <div className='total_amount_card'>
          {/* <div className='card_text '> */}
          <h3 className='total_amount_heading'>₹{Add}</h3>
          <p className='total_amount_para'>Total simple interest</p>
          {/* </div> */}
        </div> <br/>
        <div className='input_area'>
        <Stack spacing={2} direction="column"> 
        <TextField  type="number" value={num1||""} onChange={(e) => setNum1(e.target.value)}  className='input_area' id="outlined-basic" label="₹ Principal amount" variant="outlined" sx={{
        width: 300
    }}
    InputProps={{ sx: { height: 40 } }}/>
        <TextField type="number" value={num2||""} onChange={(e) => setNum2(e.target.value)} className='input_area' id="outlined-basic" label="₹Rate of interest (p.a) %" variant="outlined"  sx={{
        width: 300
    }}
    InputProps={{ sx: { height: 40  }  }}   />
        <TextField type="number" value={num3||""} onChange={(e) => setNum3(e.target.value)} className='input_area' id="outlined-basic" label="Time period ( Yr )" variant="outlined"  sx={{
        width: 300 
    }}
    InputProps={{ sx: { height: 40 ,color:'black' } }} />
       </Stack>
       </div>
       <div className='button_collection'>
          <Stack spacing={2} direction="row">       
          <Button type='submit' onClick={calcSum} className='btn_one' style={{backgroundColor: '#03a9f4'}} variant="contained">Calculate</Button>
          <Button className='btn_one' onClick={handleClick}   variant="outlined">Reset</Button>
          </Stack>
        </div>
    </div>
    
    </div>
    </>
  )
}

export default Calculater2
